<template>
  <div class="person-list my3">
    <h3 class="fs-s caps red mb0">{{ title }}</h3>
    <ul class="list-reset m1 sm-m0 md-m0 lg-m0 p0">
      <li class="relative" v-for="(item, count) in content" :ref="`item-${count}`" :key="item.id">
        <Person :item="item" />
      </li>
    </ul>
  </div>
</template>

<script>
import Person from '@/components/Person'
export default {

  name: 'PersonList',

  components: { Person },

  data () {
    return {
      openList: []
    }
  },

  props: ['title', 'content'],

  methods: {
    toggle(count) {
      this.openList[count].open = !this.openList[count].open
    }
  }

}
</script>

<style lang="css" scoped>
  .org {
    border: 1px solid var(--black);
    text-align: center;
    border-radius: 8px;
    margin-bottom: 1em;
    padding: 1em;
  }
</style>
